module.exports = __webpack_public_path__ + "img/backdrop_w.2405dc99.jpg";